import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
    dialogHeader: {
        '& .k-window-titlebar.k-header': {
            padding: theme.spacing(1, 2),
            backgroundColor: theme.palette.secondary.main,
            fontWeight: "normal"
        },
        '& .k-content': {
            boxSizing: 'border-box',
            padding: theme.spacing(0, 2),
            paddingTop: theme.spacing(1),
        },
    },
    tab: {
        border: `2px solid ${theme.palette.primary.main}`,
        textTransform: 'none',
        fontWeight: 'bold',

        '& + &': {
            borderLeftWidth: '0px',
        },
        '&.Mui-selected': {
            backgroundColor: theme.palette.primary.main,
            color: 'white',
        },
    },
    indicator: {
        backgroundColor: theme.palette.primary.main,
        color: 'red !important',
    },
}));

export default useStyles;
